import { render } from "./SectionCustom.vue?vue&type=template&id=a40f0a40"
import script from "./SectionCustom.vue?vue&type=script&lang=js"
export * from "./SectionCustom.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_22.13.1/lib/node_modules/@core/vue-cli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__